export default "__VITE_ASSET__CMLalH01__"